import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class DashboardService {
  protected subject;
  protected dashboardItems;
  public fetchItems: EventEmitter<boolean> = new EventEmitter();
  constructor() {
    this.dashboardItems = {};
    this.subject = new BehaviorSubject(this.dashboardItems);
  }
  getDashboardItems() {
    this.fetchItems.emit(true);
    return this.subject;
  }
  addDashboardItem(module, content) {
    this.dashboardItems[module] = content;
    this.subject.next(this.dashboardItems);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard.service.ts